import { Link } from "react-router-dom";

function MetricCard({ label, value, to, testId }) {
  const content = (
    <>
      <span className="feature-dashboard__metric-label">{label}</span>
      <span className="feature-dashboard__metric-value" data-testid={testId}>
        {value}
      </span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className="feature-dashboard__metric-card feature-dashboard__metric-card--link">
        {content}
      </Link>
    );
  }

  return (
    <div className="feature-dashboard__metric-card">
      {content}
    </div>
  );
}

function DashboardSection({ title, children }) {
  return (
    <section className="feature-dashboard__section" aria-label={title}>
      <h2 className="feature-dashboard__section-title">{title}</h2>
      <div className="feature-dashboard__metric-grid">{children}</div>
    </section>
  );
}

const PROPERTY_STATUS_LABELS = {
  draft: "Чернетки",
  active: "Активні",
  reserved: "Зарезервовані",
  sold: "Продані",
  archived: "В архіві",
};

const CLIENT_STATUS_LABELS = {
  lead: "Ліди",
  active: "Активні",
  inactive: "Неактивні",
  closed: "Закриті",
};

const DEAL_STATUS_LABELS = {
  pending: "Очікують",
  in_progress: "В процесі",
  closed: "Закриті",
  cancelled: "Скасовані",
};

export function DashboardSummaryView({ summary }) {
  const properties = summary.properties || {};
  const propertyByStatus = properties.by_status || {};
  const clients = summary.clients || {};
  const clientByStatus = clients.by_status || {};
  const deals = summary.deals || {};
  const dealByStatus = deals.by_status || {};
  const viewings = summary.viewings || {};
  const tasks = summary.tasks || {};
  const notifications = summary.notifications || {};

  return (
    <div className="feature-dashboard__summary">
      <DashboardSection title="Мої об'єкти">
        <MetricCard label="Усього" value={properties.total ?? 0} to="/profile" testId="dashboard-properties-total" />
        {Object.entries(PROPERTY_STATUS_LABELS).map(([status, label]) => (
          <MetricCard
            key={status}
            label={label}
            value={propertyByStatus[status] ?? 0}
            to={`/profile?property_status=${status}`}
            testId={`dashboard-property-${status}`}
          />
        ))}
      </DashboardSection>

      <DashboardSection title="CRM">
        <MetricCard label="Усього клієнтів" value={clients.total ?? 0} to="/clients" testId="dashboard-clients-total" />
        {Object.entries(CLIENT_STATUS_LABELS).map(([status, label]) => (
          <MetricCard
            key={status}
            label={label}
            value={clientByStatus[status] ?? 0}
            to={`/clients?status=${status}`}
            testId={`dashboard-client-${status}`}
          />
        ))}
        <MetricCard
          label="Нові матчі"
          value={clients.new_matches ?? 0}
          to="/clients?has_new_matches=true"
          testId="dashboard-clients-new-matches"
        />
        <MetricCard
          label="Відкриті задачі"
          value={clients.open_tasks ?? 0}
          to="/tasks"
          testId="dashboard-clients-open-tasks"
        />
        <MetricCard
          label="Клієнти з новими матчами"
          value={clients.with_new_matches ?? 0}
          to="/clients?has_new_matches=true"
          testId="dashboard-clients-with-new-matches"
        />
        <MetricCard
          label="Клієнти з простроченими задачами"
          value={clients.with_overdue_tasks ?? 0}
          to="/clients?has_overdue_tasks=true"
          testId="dashboard-clients-with-overdue-tasks"
        />
      </DashboardSection>

      <DashboardSection title="Огляди">
        <MetricCard
          label="Заплановані"
          value={viewings.scheduled ?? 0}
          testId="dashboard-viewings-scheduled"
        />
        <MetricCard
          label="Сьогодні"
          value={viewings.today ?? 0}
          testId="dashboard-viewings-today"
        />
      </DashboardSection>

      <DashboardSection title="Угоди">
        <MetricCard label="Усього" value={deals.total ?? 0} to="/deals" testId="dashboard-deals-total" />
        {Object.entries(DEAL_STATUS_LABELS).map(([status, label]) => (
          <MetricCard
            key={status}
            label={label}
            value={dealByStatus[status] ?? 0}
            to={`/deals?status=${status}`}
            testId={`dashboard-deal-${status}`}
          />
        ))}
      </DashboardSection>

      <DashboardSection title="Мої задачі">
        <MetricCard label="Відкриті" value={tasks.open ?? 0} to="/tasks" testId="dashboard-tasks-open" />
        <MetricCard label="Прострочені" value={tasks.overdue ?? 0} to="/tasks" testId="dashboard-tasks-overdue" />
      </DashboardSection>

      <DashboardSection title="Сповіщення">
        <MetricCard
          label="Непрочитані"
          value={notifications.unread ?? 0}
          to="/notifications"
          testId="dashboard-notifications-unread"
        />
      </DashboardSection>
    </div>
  );
}
